import React, { ComponentProps } from "react";
import { useNavigate } from "react-router-dom";

import "./BackButton.scss";
import BackButtonIcon from "../../icons/BackButtonIcon";
import { ThemeVariant } from "../../../utils/constants/generic-types";

interface BackButtonProps {
  style?: React.CSSProperties;
  iconProps?: ComponentProps<"svg">;
  colorVariant?: ThemeVariant;
  onClick?: () => void;
}

function BackButton({
  style,
  iconProps,
  colorVariant = ThemeVariant.LIGHT,
  onClick,
}: BackButtonProps) {
  const navigate = useNavigate();

  const navigateBack = () => {
    if (onClick) onClick();
    else navigate(-1);
  };

  return (
    <button
      aria-label="Navigate back"
      className="BackButton"
      onClick={navigateBack}
      style={style}
    >
      <BackButtonIcon
        fill={colorVariant}
        className="BackButtonIcon"
        width={30}
        height={30}
        {...iconProps}
      />
    </button>
  );
}

export default BackButton;
